import behind_mo from "../../../assets/images/behind_mo.webp";
import behind_pc from "../../../assets/images/behind_pc.webp";

export default function BehindSuccess() {
  return (
    <div
      className="w-full bg-center bg-cover bg-no-repeat py-5"
      style={{
        backgroundImage: `url(${
          window.innerWidth < 768 ? behind_mo : behind_pc
        })`,
      }}
    >
      <div className="container mx-auto p-3 grid grid-cols-1 gap-2 glg:flex lg:py-[40px] ">
        <div className="lg:flex lg:items-center lg:gap-3 ">
          <div className="lg:w-3/12 glg:flex glg:flex-col lg:gap-2 h-auto lg:h-[120px]">
            <p className="text-[28px] text-[#0C5393] font-semibold lg:w-[250px]">
              Những con người đứng sau thành công của{" "}
            </p>
            <div className="border border-[#27C6FF] w-[7.125rem] h-10 rounded-[40px] bg-[#27C6FF] flex items-center justify-center">
              <p className="text-[16px] font-normal text-white">BlueSkyIT</p>
            </div>
          </div>
          <div className="lg:w-9/12 lg:h-[120px] mt-4 ">
            <p className="text-[16px] text-[#033F6A] font-normal">
              BlueSkyIT tự hào với đội ngũ lãnh đạo và chuyên gia giàu kinh
              nghiệm, cam kết đem đến những giải pháp công nghệ tối ưu và đột
              phá cho doanh nghiệp. Chúng tôi không chỉ tập trung vào việc phát
              triển các sản phẩm chất lượng mà còn đặt khách hàng làm trọng tâm
              trong mọi hoạt động. Với tinh thần sáng tạo và phong cách làm việc
              chuyên nghiệp, BlueSkyIT luôn lắng nghe, nắm bắt nhu cầu của khách
              hàng và đối tác để tạo ra những giá trị vượt trội và bền vững.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
